import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

import { MeetingActionResponse } from './meeting.types';

@Injectable({
  providedIn: 'root'
})
export class MeetingService {
  private response = new BehaviorSubject<MeetingActionResponse>(null);
  currentResponse = this.response.asObservable();

  constructor(private messageService: MessageService) {}

  receiveActionResponse(res: MeetingActionResponse) {
    if (res.message?.key) {
      this.messageService.clear(res.message.key);
    }
    setTimeout(() => {
      if (res.message) {
        this.messageService.add(res.message);
      }
      this.response.next(res);
    });
  }
}
